var map = {
	"./arrow.svg": 4886,
	"./bar-code-error.svg": 7188,
	"./black-friday/line.svg": 8570,
	"./boleto.svg": 7521,
	"./cancelamento-error.svg": 201,
	"./cancelamento-info.svg": 7349,
	"./cancelamento-livro.svg": 3595,
	"./cancelamento-medicamento.png": 7877,
	"./cancelamento-money.svg": 6139,
	"./cancelamento-pig-bank.svg": 9298,
	"./cancelamento-success.svg": 3626,
	"./cancelamento-tem-certeza.png": 3754,
	"./cancelamento-wifi-off.svg": 3218,
	"./card-error.svg": 9889,
	"./check-active.svg": 481,
	"./check-error.svg": 3791,
	"./check-success.svg": 2084,
	"./check.svg": 3954,
	"./close-icon-blue.svg": 4761,
	"./error-icon.svg": 3650,
	"./eye.svg": 3821,
	"./icon-american-express.svg": 415,
	"./icon-barcode.svg": 254,
	"./icon-card-error.svg": 917,
	"./icon-cep-spinner.svg": 1286,
	"./icon-dinners-club.svg": 4682,
	"./icon-elo.svg": 4980,
	"./icon-iugu.svg": 5620,
	"./icon-master-card.svg": 1027,
	"./icon-visa.svg": 7909,
	"./iugu.svg": 4888,
	"./logo-elo.svg": 2970,
	"./logo-mastercard.svg": 7760,
	"./logo-other.svg": 8874,
	"./logo-visa.svg": 2547,
	"./logo-whitebook.svg": 6316,
	"./star.svg": 8946,
	"./wb-logo.svg": 6711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3672;